import { selectEventConfig } from 'models/virtual_event';
import moment from 'moment';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const useFirebaseChatConfig = () => {
  const {
    chatroomConfig: {
      isChatroomDisabled,
      isContactCardDisabled,
      hideChatHistoryDateTime,
      isFileUploadDisabled,
      isBlockingOtherExhibitors,
      isBoothChatroomDisabled,
      isAnnouncementDisabled,
      isGroupMemberListDisabled,
      isGroupVideoCallDisabled,
      isPersonalVideoCallDisabled,
      publicChatrooms = [],
    },
  } = useSelector(selectEventConfig);

  return useMemo(() => ({
    chatroomDisabled: isChatroomDisabled,
    contactCard: !isContactCardDisabled,
    hideChatMillis: hideChatHistoryDateTime ? moment(hideChatHistoryDateTime).valueOf() : null,
    fileUpload: !isFileUploadDisabled,
    exhibitorInteraction: !isBlockingOtherExhibitors, // Exhibitors cannot join other booth's chatroom
    boothChatroomDisabled: isBoothChatroomDisabled, // Hide group chat message preview, show group member list instead of chat
    announcementEnabled: !isAnnouncementDisabled,
    groupMemberList: !isGroupMemberListDisabled,
    groupVideoCall: !isGroupVideoCallDisabled,
    privateVideoCall: !isPersonalVideoCallDisabled,
    publicChatrooms,
  }), [
    isChatroomDisabled,
    isContactCardDisabled,
    hideChatHistoryDateTime,
    isFileUploadDisabled,
    isBlockingOtherExhibitors,
    isBoothChatroomDisabled,
    isAnnouncementDisabled,
    isGroupMemberListDisabled,
    isGroupVideoCallDisabled,
    isPersonalVideoCallDisabled,
    publicChatrooms,
  ]);
};

export default useFirebaseChatConfig;
